export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6844.19c1f962.jpg";